import { Box, Grid, Typography } from "@mui/material"
import i18n from "i18n-js"
import { useContext, useMemo } from "react"
import { DinamicForm } from "../../../../components"
import { AuthContext } from "../../../../context/auth"
import { canAccess } from "../../../../router/permissions"
import { actionKeys, pagesKeys } from "../../../../utils"
import { useKinventInput } from "./hooks/input"
import { useStyles } from "./styles"

export const Kinvent = ({ errors, handleChange, data }) => {
    const { state } = useContext(AuthContext)
    const kinventAccess = useMemo(() => canAccess(actionKeys.kinvent, pagesKeys.medicalcenter, state), [state])

    if (!kinventAccess) { return null }
    const { styles } = useStyles()
    const input = useKinventInput()

    return (
        <Box sx={styles.container}>
            <Typography variant="h6" color="primary">
                {i18n.t('cruds.medicalCenters.create.kinvent')}
            </Typography>

            <Grid container>
                <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
                    <Box sx={styles.inputs}>
                        <DinamicForm
                            inputs={input}
                            handleChange={handleChange}
                            values={data}
                            errors={errors || {}}
                        />
                    </Box>
                </Grid>
            </Grid>
        </Box>
    )
}